<template>
  <div class="ventrata-time-selector-container">
    <div>
      <h4 class="time-selector-title">
        Select Your Time
      </h4>
      <div v-if="selectedDate">
        <div class="date-wrapper">
          {{ onTransformDate(selectedDate) }}
        </div>
        <div v-if="availableTimeSlots.length > 0" class="time-slots-wrapper">
          <button
            v-for="availableTimeSlot in availableTimeSlots"
            :key="availableTimeSlot.id"
            class="time-slots"
            :class="{selected: selectedTimeSlot && availableTimeSlot.id === selectedTimeSlot.id}"
            @click="() => selectTime(availableTimeSlot)"
          >
            {{ formatTime(availableTimeSlot.localDateTimeStart) }}
            -
            {{ formatTime(availableTimeSlot.localDateTimeEnd) }}
          </button>
        </div>
      </div>
      <div v-if="selectedTimeSlot && selectedTimeSlot.vacancies <= 5" class="time-selector-note">
        Only <span class="time-selector-note-count">{{ selectedTimeSlot.vacancies }}</span> tickets left at these prices.
      </div>
    </div>
    <LoadingBar :loading="loading" class="ventrata-time-selector-loading" />
  </div>
</template>

<script>
import { getAvailabilityPayload, findLowestPriceAvailability } from '@/helpers/ventrata'
import { convertToTimeStr, transformDate } from '@/helpers/main'

import LoadingBar from '@/components/utils/LoadingBar'

export default {
  name: 'VentrataTimeSelector',
  components: {
    LoadingBar
  },
  props: {
    product: {
      type: Object,
      require: true
    },
    selectedDate: {
      type: String,
      require: false
    },
    currency: {
      type: String,
      require: true
    }
  },
  data () {
    return {
      availabilities: null,
      selectedTimeSlot: null,
      loading: false
    }
  },
  computed: {
    availableTimeSlots () {
      if (!this.availabilities) {
        return []
      }
      return (this.availabilities ?? [])
        .filter(item => item.available && item.vacancies !== 0)
    }
  },
  watch: {
    selectedDate (newDate) {
      if (newDate) {
        this.refreshAvailabilities()
      }
    },
    currency () {
      if (this.selectedDate) {
        this.refreshAvailabilities()
      }
    }
  },
  mounted () {
    if (this.selectedDate) {
      this.refreshAvailabilities()
    }
  },
  methods: {
    selectTime (timeSlot) {
      if (!timeSlot) {
        return
      }
      this.selectedTimeSlot = timeSlot
      this.$emit('selectTime', this.selectedTimeSlot)
    },
    formatTime (date) {
      return convertToTimeStr(date, 'h:mm A')
    },
    refreshAvailabilities () {
      this.loading = true
      const startDate = this.selectedDate
      const endDate = this.selectedDate
      this.selectedTimeSlot = null
      const availabilityPayload = getAvailabilityPayload(this.product, startDate, endDate, this.currency)
      this.$store.dispatch('ventrata/getAvailability', availabilityPayload).then((res) => {
        this.availabilities = res
        if (this.availableTimeSlots.length > 0) {
          // choose the lower price time slot 
          const lowerPriceTime = findLowestPriceAvailability(this.availableTimeSlots)
          this.selectTime(lowerPriceTime)
        }
        // console.log('availabilities: ', this.availabilities)
        this.loading = false
      })
    },
    onTransformDate (date) {
      return transformDate(date)
    }
  }
}
</script>

<style lang="scss" scoped>
.ventrata-time-selector-container {
  padding: 16px;
  position: relative;
  border-radius: 4px;
  background-color: $text-white;
  margin-top: 16px;

  .time-selector-title {
    margin: 0 0 16px 0;
    @include font__header-5();
  }

  .date-wrapper {
    @include font__subtitle-1--regular();
    color: $blackberry;
    text-align: left;
  }

  .time-slots-wrapper {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin-top: 8px;
    gap: 16px;
    row-gap: 16px;
  }

  .time-slots {
    width: calc(50% - 8px);
    height: 40px;
    background-color: transparent;
    border: 2px solid $tip-grey;
    padding: 8px 0;
    font-family: Vollkorn;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0px;
    text-align: center;
    color: $brand-primary-color;

    &.selected {
      color: $bg-grey;
      border: 1px solid $brand-primary-color;
      background-color: $brand-primary-color;
    }
    &:hover {
      cursor: pointer;
    }
  }

  .ventrata-time-selector-loading {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  .time-selector-note {
    margin-top: 16px;
    @include font__subtitle-1--regular();
    color: $brand-primary-color;
    .time-selector-note-count {
      @include font__subtitle-1--bold();
    }
  }
}

@include max-width($mobile) {
  .ventrata-time-selector-container {
    .time-selector-title {

    }
    .time-slots {

    }
  }
}
</style>
